<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>
		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="类型">
								<a-select v-model="queryParams.callType" placeholder="请选择" default-value="">
									<a-select-option value="VILTE">视频</a-select-option>
									<a-select-option value="VOLTE">语音</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="通话">
								<a-select v-model="queryParams.isConnect" placeholder="请选择" default-value="">
									<a-select-option value="Y">已接通</a-select-option>
									<a-select-option value="N">未接通</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="结算">
								<a-select v-model="queryParams.isSettle" placeholder="请选择" default-value="">
									<a-select-option value="Y">已结算</a-select-option>
									<a-select-option value="N">待结算</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						
						<template v-if="advanced">
							<a-col :span="4">
								<a-form-item label="主叫">
									<a-input v-model="queryParams.caller" placeholder="id/昵称" />
								</a-form-item>
							</a-col>
							<a-col :span="4">
								<a-form-item label="被叫">
									<a-input v-model="queryParams.called" placeholder="id/昵称" />
								</a-form-item>
							</a-col>
							<a-col :span="4">
							<a-form-item label="录音">
								<a-select v-model="queryParams.isTape" placeholder="请选择" default-value="">
									<a-select-option value="Y">有</a-select-option>
									<a-select-option value="N">无</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
							<a-col :md="8">
								<a-form-item label="时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
								:style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="rest()">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false">
				<template slot="caller" slot-scope="record">
					<div class="user" v-if="record.caller && record.caller.id">
						<div class="user-left">
							<img class="cover-img" :src="record.caller.avatarUrl || ''" width="48" height="48" alt="" @click="openUserDetail(record.caller.id)" />
						</div>
						<div class="user-right">
							<p class="first">
								<span class="nickname">{{ record.caller.nickname }}</span>
							</p>
							<p class="row">
								<span class="user-right-detail" v-if="record.caller.sex === 'MALE'">男</span>
								<span class="user-right-detail" v-else-if="record.caller.sex === 'FEMALE'">女</span>
								<span class="user-right-detail" v-if="record.caller.age != null && record.caller.age !== ''">{{ record.caller.age }}岁</span>
								<span class="user-right-detail">{{ record.caller.province }}{{ record.caller.city }}</span>
							</p>
						</div>
					</div>
					<span v-else class="user-empty">-</span>
				</template>

				<template slot="called" slot-scope="record">
					<div class="user" v-if="record.called && record.called.id">
						<div class="user-left">
							<img class="cover-img" :src="record.called.avatarUrl || ''" width="48" height="48" alt="" @click="openUserDetail(record.called.id)" />
						</div>
						<div class="user-right">
							<p class="first">
								<span class="nickname">{{ record.called.nickname }}</span>
							</p>
							<p class="row">
								<span class="user-right-detail" v-if="record.called.sex === 'MALE'">男</span>
								<span class="user-right-detail" v-else-if="record.called.sex === 'FEMALE'">女</span>
								<span class="user-right-detail" v-if="record.called.age != null && record.called.age !== ''">{{ record.called.age }}岁</span>
								<span class="user-right-detail">{{ record.called.province }}{{ record.called.city }}</span>
							</p>
						</div>
					</div>
					<span v-else class="user-empty">-</span>
				</template>

				<template slot="type" slot-scope="record">
					<div>
						<span v-if="record.callType=='VILTE'">视频</span>
						<span v-else>语音</span>
					</div>
				</template>

				<template slot="chat" slot-scope="record">
					<div class="complex">
                        <span v-if="record.status == 'INVITE'" class="processing">呼叫中</span>
                        <span v-else-if="record.status == 'CALLING'" class="processing">正在通话</span>
                        <div v-else>
                            <div v-if="record.isConnect=='Y'">
                                <span>通话结束</span>
								<p class="depict" v-if="record.callLen">{{record.callLen}}</p>
							</div>
                            <div v-else>
                                <span class="error">未接通</span>
                            </div>
                        </div>
                        <p class="depict" v-if="record.hangup==1">被叫拒绝</p>
                        <p class="depict" v-else-if="record.hangup==2">被叫未接听</p>
                        <p class="depict" v-else-if="record.hangup==3">主叫取消</p>
                        <p class="depict" v-else-if="record.hangup==4">支出方金币不足挂断</p>
                        <p class="depict" v-else-if="record.hangup==5">违规中断</p>
					</div>
				</template>

                <template slot="bill" slot-scope="record">
                    <span v-if="record.billMinutes > 0">{{ record.billMinutes }}分钟</span>
                    <span v-else>-</span>
                </template>

				<template slot="expend" slot-scope="record">
					<div class="complex" v-if="record.userExpend > 0">
                        <span>{{ record.userExpend }}金币</span>
                        <p class="depict">{{ record.expendUserNickname }}</p>
					</div>
                    <span v-else>-</span>
				</template>

                <template slot="income" slot-scope="record">
                    <div class="complex" v-if="record.userIncome > 0">
                        <span>{{ record.userIncome }}积分<label class="rate"> - {{ record.profitRate }}</label></span>
                        <p class="depict">{{ record.incomeUserNickname }}</p>
                    </div>
                    <span v-else>-</span>
                </template>

                <template slot="violation" slot-scope="record">
                    <span v-if="record.isViolation == 'Y'" class="error">违规</span>
                    <span v-else>正常</span>
                </template>

                <template slot="settle" slot-scope="record">
                    <div class="complex">
                        <div v-if="record.isSettle == 'Y'">
                            <span>已结算</span>
                            <p class="depict">{{ record.settleTime }}</p>
                        </div>
                        <span v-else class="warning">未结算</span>
                    </div>
                </template>

                <template slot="action" slot-scope="record">
                    <a @click="openDetail(record)">详情</a>
                </template>

			</a-table>

			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>
		</a-card>

		<a-drawer
			placement="right"
			:width="640"
			:visible="detailVisible"
			:destroyOnClose="true"
			wrap-class-name="call-detail-drawer"
			@close="closeDetail"
		>
			<div slot="title" class="call-detail-drawer-title">
				<span>{{ detailDrawerTitle }}</span>
				<a
					v-if="detailPlayUrl"
					class="title-play-btn"
					@click="playDetailTape"
				>{{ detailPlaying ? '暂停' : '播放' }}</a>
			</div>
			<a-spin :spinning="detailLoading">
				<template v-if="detailRecord">
					<div class="call-users">
						<div class="call-user">
							<div class="call-user-role">主叫</div>
							<img
								class="call-user-avatar"
								:src="(detailRecord.caller && detailRecord.caller.avatarUrl) || ''"
								alt=""
							/>
							<div class="call-user-name">{{ (detailRecord.caller && detailRecord.caller.nickname) || '-' }}</div>
						</div>
						<div class="call-user">
							<div class="call-user-role">被叫</div>
							<img
								class="call-user-avatar"
								:src="(detailRecord.called && detailRecord.called.avatarUrl) || ''"
								alt=""
							/>
							<div class="call-user-name">{{ (detailRecord.called && detailRecord.called.nickname) || '-' }}</div>
						</div>
					</div>

					<a-descriptions bordered size="small" :column="1" class="call-desc">
						<a-descriptions-item label="通话状态">{{ statusText(detailRecord) }}</a-descriptions-item>
						<a-descriptions-item label="挂断原因">{{ hangupText(detailRecord.hangup) }}</a-descriptions-item>
						<a-descriptions-item label="通话时长">{{ detailRecord.callLen || '-' }}</a-descriptions-item>
						<a-descriptions-item label="账单时长">
							{{ detailRecord.billMinutes > 0 ? detailRecord.billMinutes + '分钟' : '-' }}
						</a-descriptions-item>
						<a-descriptions-item label="开始时间">{{ detailRecord.startTimeText || '-' }}</a-descriptions-item>
						<a-descriptions-item label="结束时间">{{ detailRecord.endTimeText || '-' }}</a-descriptions-item>
						<a-descriptions-item label="支出">
							<span v-if="detailRecord.userExpend > 0">
								{{ detailRecord.userExpend }}金币
								<span class="assist" v-if="detailRecord.expendUserNickname">（{{ detailRecord.expendUserNickname }}）</span>
							</span>
							<span v-else>-</span>
						</a-descriptions-item>
						<a-descriptions-item label="收入">
							<span v-if="detailRecord.userIncome > 0">
								{{ detailRecord.userIncome }}积分
								<span class="assist" v-if="detailRecord.incomeUserNickname">（{{ detailRecord.incomeUserNickname }}）</span>
							</span>
							<span v-else>-</span>
						</a-descriptions-item>
					</a-descriptions>

					<div class="violation-block" v-if="detailViolationList.length">
						<div class="violation-title">违规记录</div>
						<div
							v-for="item in detailViolationList"
							:key="item.id"
							class="violation-item"
						>
							<span class="error">{{ riskLevelText(item.riskLevel) }}</span>
							<span class="assist" v-if="item.created"> · {{ formatViolationTime(item.created) }}</span>
						</div>
					</div>

					<div class="violation-block" v-if="detailViolationImages.length">
						<div class="violation-title">违规截图</div>
						<div class="violation-images">
							<img
								v-for="(img, idx) in detailViolationImages"
								:key="idx"
								class="violation-thumb"
								:src="img"
								alt="违规截图"
								@click="openViolationPreview(img)"
							/>
						</div>
					</div>
					<div class="violation-block" v-else-if="detailRecord.isViolation === 'Y'">
						<div class="violation-title">违规截图</div>
						<div class="assist">暂未解析到截图地址</div>
					</div>
				</template>
			</a-spin>
		</a-drawer>

		<a-modal
			:visible="violationPreviewVisible"
			:footer="null"
			:width="480"
			:zIndex="3000"
			:getContainer="getModalContainer"
			destroyOnClose
			centered
			@cancel="closeViolationPreview"
		>
			<div class="violation-preview-wrap">
				<img v-if="violationPreviewUrl" :src="violationPreviewUrl" alt="违规截图预览" class="violation-preview-img" />
			</div>
		</a-modal>
		
		<a-modal v-model="videoModalVisible" :width="720" :footer="null" :destroyOnClose="true"
			@cancel="closeVideoModal">
			<video ref="videoPlayer" controls :src="currentVideoUrl" height="400px" style="width: 100%;">
		
			</video>
		</a-modal>
		<user-detail-drawer ref="userDetailDrawer" />
	</div>
</template>

<script>
	import {
		callList,
		callDetail
	} from "@/api/op/call";
	import moment from "moment/moment";
	import UserDetailDrawer from "@/components/UserDetailDrawer.vue";

	const tableColumns = [{
			title: '#',
			dataIndex: 'id',
		},
		{
			title: '类型',
			scopedSlots: {
				customRender: 'type'
			}
		},
		{
			title: '主叫',
			scopedSlots: {
				customRender: 'caller'
			}
		},
		{
			title: '被叫',
			scopedSlots: {
				customRender: 'called'
			}
		},
        {
            title: '通话',
            scopedSlots: {
                customRender: 'chat'
            }
        },
        {
            title: '账单',
            scopedSlots: {
                customRender: 'bill'
            }
        },
		{
			title: '支出',
			scopedSlots: {
				customRender: 'expend'
			}
		},
        {
            title: '分润',
            scopedSlots: {
                customRender: 'income'
            }
        },
        {
            title: '风控',
            scopedSlots: {
                customRender: 'violation'
            }
        },
        {
            title: '结算',
            scopedSlots: {
                customRender: 'settle'
            }
        },
		{
			title: '创建时间',
			dataIndex: 'created'
		},
        {
            title: '操作',
            scopedSlots: {
                customRender: 'action'
            }
        }
	];

	export default {
		components: {
			UserDetailDrawer,
		},
		data() {
			return {
				advanced: false,
				queryParams: {},
				totalRow: 0,
				tableColumns,
				tableData: [],
				tableLoading: false,
				pageSize: 20,
				pageIndex: 1,
				isPlaying: false,
				createTime: [],

				currentPlaying: null, // 当前正在播放的录音ID
				audioPlayers: {}, // 存储audio实例
				
				videoModalVisible: false, // 控制视频弹窗的显示
				currentVideoUrl: '', // 当前要播放的视频URL

				detailVisible: false,
				detailLoading: false,
				detailRecord: null,
				detailViolationImages: [],
				violationPreviewVisible: false,
				violationPreviewUrl: ''
			}
		},
		computed: {
			detailDrawerTitle() {
				if (!this.detailRecord) {
					return '通话详情';
				}
				const type = this.callTypeText(this.detailRecord.callType);
				return `${type} (${this.detailRecord.id})`;
			},
			detailPlayUrl() {
				if (!this.detailRecord) {
					return '';
				}
				return this.detailRecord.tapeUrl || '';
			},
			detailPlaying() {
				return !!(this.detailRecord && this.currentPlaying === this.detailRecord.id);
			},
			detailViolationList() {
				if (!this.detailRecord || !Array.isArray(this.detailRecord.violationList)) {
					return [];
				}
				return this.detailRecord.violationList;
			},
			detailRiskLevelText() {
				const list = this.detailViolationList;
				if (!list.length) {
					return '';
				}
				let maxLevel = null;
				list.forEach(item => {
					const level = Number(item.riskLevel);
					if (!Number.isNaN(level) && (maxLevel === null || level > maxLevel)) {
						maxLevel = level;
					}
				});
				return maxLevel === null ? '' : this.riskLevelText(maxLevel);
			}
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				callList(this.queryParams).then(res => {
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList;
					this.tableLoading = false;
				});
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			onCreateTime(values) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			rest() {
				this.createTime = [];
				this.queryParams = {}
			},

			openUserDetail(id) {
				if (this.$refs.userDetailDrawer) {
					this.$refs.userDetailDrawer.open(id);
				}
			},
			openDetail(record) {
				if (!record || !record.id) {
					return;
				}
				this.detailVisible = true;
				this.detailLoading = true;
				this.detailRecord = null;
				this.detailViolationImages = [];
				callDetail(record.id).then(res => {
					if (!res.isSucceed) {
						this.$message.error(res.message || '获取详情失败');
						this.detailVisible = false;
						return;
					}
					this.detailRecord = res.data || null;
					this.detailViolationImages = this.parseViolationImages(res.data);
				}).finally(() => {
					this.detailLoading = false;
				});
			},
			closeDetail() {
				this.stopPlayback();
				this.closeViolationPreview();
				this.detailVisible = false;
				this.detailRecord = null;
				this.detailViolationImages = [];
			},
			playDetailTape() {
				if (!this.detailPlayUrl || !this.detailRecord) {
					return;
				}
				// 视频走弹层，语音直接播放不弹层
				if (this.detailRecord.callType === 'VILTE') {
					this.openVideoModal(this.detailPlayUrl);
					return;
				}
				const id = this.detailRecord.id;
				const cached = this.audioPlayers[id];
				if (cached && cached.src !== this.detailPlayUrl) {
					cached.pause();
					delete this.audioPlayers[id];
				}
				this.togglePlay({ id, tapeUrl: this.detailPlayUrl });
			},
			getModalContainer() {
				return document.body;
			},
			openViolationPreview(url) {
				if (!url) return;
				this.violationPreviewUrl = url;
				this.violationPreviewVisible = true;
			},
			closeViolationPreview() {
				this.violationPreviewVisible = false;
				this.violationPreviewUrl = '';
			},
			callTypeText(callType) {
				return callType === 'VILTE' ? '视频通话' : '语音通话';
			},
			statusText(record) {
				if (!record) return '-';
				if (record.status === 'INVITE') return '呼叫中';
				if (record.status === 'CALLING') return '正在通话';
				if (record.isConnect === 'Y') return '通话结束';
				return '未接通';
			},
			hangupText(hangup) {
				const map = {
					0: '-',
					1: '被叫拒绝',
					2: '被叫未接听',
					3: '主叫取消',
					4: '支出方金币不足',
					5: '违规中断',
					6: '回调异常'
				};
				return map[hangup] != null ? map[hangup] : '-';
			},
			riskLevelText(level) {
				const map = {
					0: '无风险',
					1: '低风险',
					2: '中风险',
					3: '高风险',
					4: '极高风险'
				};
				if (level === null || level === undefined || level === '') {
					return '未知等级';
				}
				const key = Number(level);
				if (map[key] != null) {
					return map[key];
				}
				return `等级${level}`;
			},
			formatViolationTime(created) {
				if (!created) return '';
				if (typeof created === 'number') {
					return moment(created * (created < 1e12 ? 1000 : 1)).format('YYYY-MM-DD HH:mm:ss');
				}
				return created;
			},
			parseViolationImages(detail) {
				if (!detail) return [];
				if (Array.isArray(detail.violationImages) && detail.violationImages.length) {
					return detail.violationImages;
				}
				const list = detail.violationList || [];
				const images = [];
				list.forEach(item => {
					if (Array.isArray(item.images)) {
						item.images.forEach(url => {
							if (url && images.indexOf(url) === -1) images.push(url);
						});
					}
					this.extractImageUrlsFromContent(item.content).forEach(url => {
						if (images.indexOf(url) === -1) images.push(url);
					});
				});
				return images;
			},
			extractImageUrlsFromContent(content) {
				if (!content || typeof content !== 'string') return [];
				const urls = [];
				try {
					const json = JSON.parse(content);
					this.collectImageUrls(json, urls);
				} catch (e) {
					// ignore
				}
				const matched = content.match(/https?:\/\/[^\s"'<>\\]+/gi) || [];
				matched.forEach(url => {
					const clean = url.replace(/[.,;)\]]+$/, '');
					if (/(\.(jpg|jpeg|png|gif|webp|bmp)(\?|$))|(screenshot|image|img)/i.test(clean)) {
						if (urls.indexOf(clean) === -1) urls.push(clean);
					}
				});
				return urls;
			},
			collectImageUrls(data, urls) {
				if (!data || typeof data !== 'object') return;
				const keys = ['url', 'image', 'imageUrl', 'image_url', 'screenshot', 'screenshotUrl', 'pic', 'photo'];
				Object.keys(data).forEach(key => {
					const value = data[key];
					if (value && typeof value === 'object') {
						this.collectImageUrls(value, urls);
						return;
					}
					if (typeof value === 'string' && /^https?:\/\//i.test(value)) {
						if (keys.indexOf(key) !== -1 || /(\.(jpg|jpeg|png|gif|webp|bmp)(\?|$))|(screenshot|image|img)/i.test(value)) {
							if (urls.indexOf(value) === -1) urls.push(value);
						}
					}
				});
			},

			// 初始化audio播放器
			initAudioPlayer(record) {
				if (!this.audioPlayers[record.id]) {
					// 创建新的audio实例
					const audio = new Audio(record.tapeUrl);
					audio.preload = 'none';

					// 监听音频结束事件
					audio.addEventListener('ended', () => {
						this.currentPlaying = null;
					});

					// 存储audio实例
					this.audioPlayers[record.id] = audio;
				}

				return this.audioPlayers[record.id];
			},

			togglePlay(record) {
				// 如果点击的是当前正在播放的录音
				if (this.currentPlaying === record.id) {
					this.stopPlayback();
					return;
				}

				// 停止当前播放的录音（如果有）
				if (this.currentPlaying) {
					this.stopPlayback();
				}

				// 初始化并开始播放新录音
				const audioElement = this.initAudioPlayer(record);
				this.currentPlaying = record.id;
				audioElement.play().catch(error => {
					console.error('播放失败:', error);
					this.currentPlaying = null;
				});
			},

			stopPlayback() {
				if (this.currentPlaying && this.audioPlayers[this.currentPlaying]) {
					const audioElement = this.audioPlayers[this.currentPlaying];
					audioElement.pause();
					audioElement.currentTime = 0;
					this.currentPlaying = null;
				}
			},

			/**
			 * 打开视频弹窗并开始播放
			 * @param {string} videoUrl - 视频的URL
			 */
			openVideoModal(videoUrl) {
				this.currentVideoUrl = videoUrl;
				this.videoModalVisible = true; // 显示Modal

				// 在Modal显示后自动播放视频（注意浏览器自动播放策略）
				this.$nextTick(() => {
					const videoElem = this.$refs.videoPlayer;
					if (videoElem) {
						// 注意：许多浏览器要求带有声音的媒体必须由用户交互（如点击）后才能自动播放。
						// 可以尝试静音后播放，或者等待用户点击video自带的控制条播放按钮。
						videoElem.play().catch(error => {
							console.error('自动播放失败:', error);
							// 处理自动播放被阻止的情况，例如提示用户手动点击播放
						});
					}
				});
			},

			/**
			 * 关闭视频弹窗并暂停播放
			 */
			closeVideoModal() {
				this.videoModalVisible = false;
				const videoElem = this.$refs.videoPlayer;
				if (videoElem) {
					videoElem.pause(); // 暂停视频播放[6](@ref)
					// videoElem.currentTime = 0; // 可选：将进度重置到开头
				}
			},
		},
		beforeDestroy() {
			// 组件销毁前停止所有播放并清理资源
			this.stopPlayback();

			// 移除所有audio实例
			Object.values(this.audioPlayers).forEach(audio => {
				audio.pause();
				audio.src = '';
				audio.load();
			});

			this.audioPlayers = {};
		}
	}
</script>

<style lang="less" scoped>
	.user {
		display: flex;
		flex-direction: row;

		.user-left {
			display: flex;
			flex-direction: column;
			margin-right: 8px;
			text-align: center;

			.cover-img {
				border-radius: 4px;
				object-fit: cover;
				cursor: pointer;
			}
		}

		.user-right {
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			p.first {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				align-items: center;
				margin: 0;

				.nickname {
					color: #686868;
					font-weight: bold;
				}

				.user-id {
					font-size: 12px;
					color: #acacac;
				}
			}

			p.row {
				font-size: 12px;
				color: #acacac;
				margin: 0;
			}

			.user-right-detail {
				margin-right: 5px;
			}
		}
	}

	.user-empty {
		color: #acacac;
		font-size: 12px;
	}

	.complex {
		display: flex;
		flex-direction: column;
	}

    .depict {
        margin: 0;
        font-size: 12px;
        color: #ccc;
    }

	a.playing {
		color: #f5222d;
	}

	.price-span {
		font-size: 12px;
		color: #ccc;
	}

	.play-audio, .video-thumbnail {
		margin-left: 5px;
	}

	.calling-span {
		font-size: 12px;
		color: #f59a23;
	}

	.rate {
        font-size: 12px;
		color: #ccc;
	}

	.assist {
		font-size: 12px;
        color: #acacac;
	}

	.call-users {
		display: flex;
		justify-content: space-around;
		align-items: flex-start;
		padding: 8px 0 24px;
		border-bottom: 1px solid #f0f0f0;
		margin-bottom: 16px;
	}

	.call-user {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 40%;
	}

	.call-user-role {
		font-size: 13px;
		color: #8c8c8c;
		margin-bottom: 10px;
	}

	.call-user-avatar {
		width: 64px;
		height: 64px;
		border-radius: 6px;
		object-fit: cover;
		background: #f5f5f5;
		margin-bottom: 8px;
	}

	.call-user-name {
		font-size: 14px;
		color: #262626;
		font-weight: 500;
		text-align: center;
		word-break: break-all;
	}

	.call-desc {
		margin-bottom: 20px;
	}

	.violation-block {
		margin-top: 8px;
	}

	.violation-title {
		font-size: 14px;
		font-weight: 500;
		color: #262626;
		margin-bottom: 12px;
	}

	.violation-item {
		font-size: 13px;
		margin-bottom: 6px;
	}

	.violation-images {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
	}

	.violation-thumb {
		width: 88px;
		height: 88px;
		object-fit: cover;
		border-radius: 6px;
		cursor: pointer;
		background: #f5f5f5;
		border: 1px solid #f0f0f0;
	}

	.violation-preview-wrap {
		display: flex;
		align-items: center;
		justify-content: center;
		max-height: 60vh;
		overflow: hidden;
	}

	.violation-preview-img {
		max-width: 100%;
		max-height: 60vh;
		object-fit: contain;
		display: block;
	}

	.error {
		color: #f5222d;
	}

	.warning {
		color: #fa8c16;
	}

	.processing {
		color: #1890ff;
	}
</style>

<style lang="less">
	.call-detail-drawer {
		.call-detail-drawer-title {
			display: flex;
			align-items: center;
		}

		.call-detail-drawer-title a.title-play-btn {
			margin-left: 8px;
			font-size: 14px;
			color: transparent !important;
			cursor: pointer;
		}
	}
</style>